import React from 'react';
import Text from '../../../Components/Base/Text/Text';
// @ts-ignore
import styles from './HealthPlanModal.module.scss';

interface HealthPlanModalProps {
	description?: string;
	subtitle?: string;
	items: number;
	modalExtraText: string[];
	modalItemPrefix: string;
	modalImages?: string[];
}

const HealthPlanModal: React.FC<HealthPlanModalProps> = ({
	description,
	subtitle,
	items,
	modalExtraText,
	modalItemPrefix,
	modalImages,
}) => (
	<>
		<div>
			<div>
				<Text
					tx={description ?? 'component.baby.infoModal.description'}
					className='pb-2'
				/>
			</div>
			<div className='d-flex my-3 mr-3 justify-content-center'>
				{modalImages?.length &&
					modalImages.map((item, key) => {
						return (
							<img
								src={item}
								key={key}
								width='100px'
								className={styles.image}
							/>
						);
					})}
			</div>
		</div>
		{modalExtraText?.map((t, i) => (
			<Text tx={t} key={i} />
		))}
		<ul className='pt-2'>
			{[...Array(items)].map((_, i) => (
				<li key={i}>
					<Text inline tx={`${modalItemPrefix}.item${i + 1}`} />
				</li>
			))}
		</ul>
		<Text tx={subtitle ?? 'component.baby.infoModal.subtitle'} />
	</>
);
export default HealthPlanModal;
